"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_LOCALE = 'en';
var getSaleType = function (saleType, daysLeft) {
    if (daysLeft === void 0) { daysLeft = 0; }
    if (saleType === "Seasonal" /* SEASONAL */ && daysLeft === 1) {
        return "lastSaleDay" /* LAST_SALE_DAY */;
    }
    if (saleType === "Seasonal" /* SEASONAL */) {
        return "sale" /* SALE */;
    }
    if (saleType === "None" /* NO_SALE */) {
        return "None" /* NO_SALE */;
    }
    return saleType;
};
exports.getParamExtractingStrategies = function (context, path) {
    var locale = context.locale, saleType = context.saleType, daysLeft = context.daysLeft;
    var sale = getSaleType(saleType, daysLeft);
    if (sale === "lastSaleDay" /* LAST_SALE_DAY */) {
        return [
            [locale, "lastSaleDay" /* LAST_SALE_DAY */].concat(path),
            [locale, "sale" /* SALE */].concat(path),
            [locale].concat(path),
            [DEFAULT_LOCALE, "lastSaleDay" /* LAST_SALE_DAY */].concat(path),
            [DEFAULT_LOCALE, "sale" /* SALE */].concat(path),
            [DEFAULT_LOCALE].concat(path),
            path.slice(),
        ];
    }
    if (sale !== "None" /* NO_SALE */) {
        return [
            [locale, sale].concat(path),
            [locale].concat(path),
            [DEFAULT_LOCALE, sale].concat(path),
            [DEFAULT_LOCALE].concat(path),
            path.slice(),
        ];
    }
    return [[locale].concat(path), [DEFAULT_LOCALE].concat(path), path.slice()];
};
//# sourceMappingURL=FallbackMapper.js.map